














































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Lists, { typeLists } from './Service/Lists';
import Delete from './Service/Delete';
import roleForm from './form.json';
import create from './create.vue';
import advSearch from './advSearch.vue';

/** 從物件或物件陣列中分離出guid */
const getGuid = (selected: any): any => {
  if (Array.isArray(selected)) {
    return selected.map((x: typeLists.listItem) => x.p5_role_id);
  }
  return selected.p5_role_id;
};

/** 從物件或物件陣列中分離出名稱 */
const getName = (selected: any): string => {
  if (Array.isArray(selected)) {
    const result: any = selected.map((x: typeLists.listItem) => x.p3_bre_name);
    return result.join(', ');
  }
  return selected.p3_bre_name;
};

@Component({
  components: {
    create,
    advSearch,
  },
})
export default class roleLists extends Vue {
  @Prop({
    default() {
      return { width: 0, height: 0 };
    },
  })
  private contentSize!: any;

  private loading: boolean = false; // 讀取中

  private roleForm: Object = roleForm;

  private tableData: typeLists.listItem[] = [];

  private selected: typeLists.listItem[] = [];

  private dialogCreate: boolean = false;

  private dialogAdvSearch: boolean = false;

  // table選擇的項目
  private handleSelectionChange(val: typeLists.listItem[]): void {
    this.selected = val;
  }

  private sortChange(column: any) {
    this.$store.commit('sortChange', column);
  }

  /**
   * setModify 編輯功能
   */
  public setModify(item: typeLists.listItem) {
    const guid = item.p5_role_id;
    this.$router.push(`/permission/role/modify/${guid}`);
  }

  /** 取得列表 */
  public getLists(params?: typeLists.request): void {
    this.loading = true;
    const getter = new Lists(params);
    getter.get().then((d: typeLists.response) => {
      this.tableData = d.list;
      this.loading = false;
    });
  }

  /** 刪除功能，可複選 */
  public doDelete(item: any) {
    const doDelete = new Delete(item);
    doDelete.delete().then(() => {
      this.selected = [];
      this.getLists();
    });
  }

  private mounted() {
    /** 從bus偵測新增行為 */
    this.$bus.$on('create', () => {
      this.dialogCreate = true;
    });

    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('delete', () => {
      this.doDelete(this.selected);
    });

    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('advSearch', () => {
      this.dialogAdvSearch = true;
    });

    this.getLists();
  }

  beforeRouteUpdate(to: any, from: any, next: Function) {
    next();
    this.getLists();
  }
}
